export type MonitorServiceTeamSelection = {
  value: string;
  label: string;
};

const INVALID_MONITOR_SERVICE_TEAM_SELECTOR = "__invalid_monitor_service_team_selection__";

function canonicalSelection(value: unknown): MonitorServiceTeamSelection | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const selection = value as { value?: unknown; label?: unknown };
  if (typeof selection.value !== "string" || typeof selection.label !== "string") return null;
  const team = selection.value.trim();
  const label = selection.label.trim();
  if (!team || !label) return null;
  return { value: team, label };
}

export function normalizeMonitorServiceTeamSelections(value: unknown): MonitorServiceTeamSelection[] {
  if (!Array.isArray(value)) return [];
  const selections: MonitorServiceTeamSelection[] = [];
  const seen = new Set<string>();
  for (const valueSelection of value) {
    const selection = canonicalSelection(valueSelection);
    if (!selection || seen.has(selection.value)) continue;
    seen.add(selection.value);
    selections.push(selection);
  }
  return selections;
}

export function parseMonitorServiceTeamSelections(value: unknown): MonitorServiceTeamSelection[] {
  if (typeof value !== "string" || !value) return [];
  try {
    return normalizeMonitorServiceTeamSelections(JSON.parse(value));
  } catch {
    return [];
  }
}

export function serializeMonitorServiceTeamSelections(value: unknown): string {
  return JSON.stringify(normalizeMonitorServiceTeamSelections(value));
}

export function normalizeMonitorViewServiceTeams<T extends Record<string, unknown>>(view: T): T {
  if (view.service_team_all) return { ...view, service_team_specific: null };
  return {
    ...view,
    service_team_specific: serializeMonitorServiceTeamSelections(
      parseMonitorServiceTeamSelections(view.service_team_specific),
    ),
  };
}

export function monitorServiceTeamQueryValues(view: Record<string, unknown>, selections: unknown): string[] {
  const values = normalizeMonitorServiceTeamSelections(selections).map((selection) => selection.value);
  if (values.length > 0 || view.service_team_all !== false) return values;
  return [INVALID_MONITOR_SERVICE_TEAM_SELECTOR];
}
